import { httpRequest } from '@/services/httpClient'

export type NaceCodeItem = {
  id: number
  code: string
  language: string
  name: string
  level: string | null
  parentCode: string | null
  section: string | null
  division: string | null
  group: string | null
  naceClass: string | null
  subclass: string | null
  sortOrder: number
  isActive: boolean
  createdAt: string
  updatedAt: string | null
}

export type NaceCodeListResponse = {
  items: NaceCodeItem[]
  totalCount: number
  page: number
  pageSize: number
}

export type NaceCodeListParams = {
  lang: string
  search?: string
  page?: number
  pageSize?: number
  sortBy?: 'code' | 'name' | 'section' | 'sortOrder'
  sortDir?: 'asc' | 'desc'
}

export type NaceCodeCreateUpdatePayload = {
  code: string
  name: string
  language: string
  level?: string
  parentCode?: string
  section?: string
  division?: string
  group?: string
  naceClass?: string
  subclass?: string
  sortOrder?: number
  isActive?: boolean
}

export type NaceCodeCreateResponse = {
  id: number
  code: string
  language: string
  name: string
}

export const LANGUAGES = [
  { value: 'tr', label: 'Türkçe' },
  { value: 'en', label: 'English' },
  { value: 'az', label: 'Azərbaycan' },
] as const

export const naceCodesApi = {
  list: (params: NaceCodeListParams) =>
    httpRequest<NaceCodeListResponse>('/v1/lookups/nace-codes', {
      method: 'GET',
      query: {
        lang: params.lang,
        search: params.search?.trim() || undefined,
        page: params.page ?? 1,
        pageSize: params.pageSize ?? 10,
        sortBy: params.sortBy,
        sortDir: params.sortDir,
      },
    }),

  getById: (id: number) =>
    httpRequest<NaceCodeItem>(`/v1/lookups/nace-codes/${id}`, { method: 'GET' }),

  create: (payload: NaceCodeCreateUpdatePayload) =>
    httpRequest<NaceCodeCreateResponse>('/v1/lookups/nace-codes', {
      method: 'POST',
      body: payload,
    }),

  update: (id: number, payload: NaceCodeCreateUpdatePayload) =>
    httpRequest<NaceCodeItem>(`/v1/lookups/nace-codes/${id}`, {
      method: 'PUT',
      body: payload,
    }),

  delete: (id: number) =>
    httpRequest<undefined>(`/v1/lookups/nace-codes/${id}`, { method: 'DELETE' }),
}
